window.addEventListener('DOMContentLoaded', function() {
    (function($) {
	
		let serviceListSection = $('.service-list a');

		serviceListSection.click(function(evt) {
			evt.preventDefault();

			 const link = $(this).attr('href');

			 serviceListSection.removeClass('active');
			 $(this).addClass('active');

			 $('.service-wrapper').removeClass('active');
			 $(link).addClass('active');


		});

		/*Only for mobile*/
		let serviceListSectionMobile = $('.service-list.mobile a');

		serviceListSectionMobile.click(function(evt) {
			evt.preventDefault();

			const linkMobile = $(this).attr('href');


		    var click = $(this).data('clicks');

		    if (click) {
		    	$('.service-wrapper').slideUp('slow');
		 		$(this).removeClass('active');
		     
		    }else{
		    	$('.service-wrapper').slideUp('slow');
				$(this).next().find(linkMobile).slideDown('slow');
		        
		    };

		    $(this).data('clicks', !click);

		});

		let processListSection = $('.our-process-items-list a');

		processListSection.click(function(evt) {
			evt.preventDefault();

			 const link = $(this).attr('href');

			 processListSection.removeClass('active');
			 $(this).addClass('active');

			 $('.our-process-items').removeClass('active');
			 $(link).addClass('active')

		});


		let question = $('.question-group .question');

		question.click(function(evt) {
			evt.preventDefault();


			var click = $(this).data('clicks');

		    if (click) {
		    	question.removeClass('active');
		    	question.next().slideUp('slow');
				//$(this).next().slideDown('slow');
		     
		    }else{
				$(this).addClass('active');
		    	question.next().slideUp('slow');
				$(this).next().slideDown('slow');
		        
		    };

		    $(this).data('clicks', !click);


		});

		let galleryTitle = $('.gallery-title-view');

		galleryTitle.click(function(evt) {
			evt.preventDefault();

			$('.gallery-filter').removeClass('active');
			$(this).parent('.gallery-filter').addClass('active');


		});

		$('.gallery-fitler-data').click(function(evt) {
			evt.preventDefault();

			var text = $(this).find('span').text();
			$('.gallery-title-view').find('span').html(text);

			var id = $(this).attr('data-filter');
			$('.gallery-slider').removeClass('active');
			$(id).addClass('active');

			$(this).parents('.gallery-filter').removeClass('active');

  			



  			const link = id;

			 $('.gallery-fitler-data').removeClass('gallery-select');
			 $(this).addClass('gallery-select');

			 $('.gallery-slider-desktop .gallery-slider').removeClass('active');
			 $(link).addClass('active');

			 $('.gallery-grid-list .gallery-grid').removeClass('active');
			 $('.gallery-grid-list ' + link+'-grid').addClass('active');

			

			 // if ($(link).hasClass('active')) {
			 // 	$(link).slick.refresh(); 
			 // }

	    });
 


	$('.tabs-details .text-group .heading-wrap').click(function() {
        $(this).next().slideToggle();
        $( this ).find('svg').toggleClass( "up" );
    });

	

	$('.gallery-view-all .open_grid').click(function(evt) {
		evt.preventDefault();
		evt.stopPropagation();
 
		$(this).parents('.gallery-view-all').addClass('active');
		$('.gallery-slider-main').addClass('grid_is_open');


		var id = $('.gallery-filter-data-wrap').find('.gallery-select').attr('data-filter');


		
		$('.gallery-slider-list .gallery-slider').removeClass('active')

		$('.gallery-grid-list '+id+'-grid').removeClass('active');
		$('.gallery-grid-list '+id+'-grid').addClass('active');





		


		 


    });
    $('.gallery-view-all .close_grid').click(function(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		$(this).parents('.gallery-view-all').removeClass('active');
		$('.gallery-slider-main').removeClass('grid_is_open');


		var id = $('.gallery-filter-data-wrap').find('.gallery-select').attr('data-filter');


		$('.gallery-grid-list .gallery-grid').removeClass('active');
		
		$('.gallery-slider-list .gallery-slider').removeClass('active');
		$('.gallery-slider-list ' + id).addClass('active');
		
		

		if ($(id).hasClass('active')) {

		 	$('.gallery-slider-desktop ' +id)[0].slick.refresh(); 
		 }
  
		

	

    });

	var url = window.location.href;
	if( url.indexOf('#') > -1){
		id = url.split("#")[1];

		$('[data-filter="#'+id+'"]').click();
		$("html").animate({ scrollTop: 0 }, "slow");


		// $('.gallery-list-name [href="#'+id+'"]').click();
	 //    $('html, body').animate({scrollTop:0},500)

	}

	


	})(jQuery);
});

class FeaturedCollectionNew extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.featured-collection-slider');
    this.leftArrow = this.querySelector('.arrow-position .left');
    this.rightArrow = this.querySelector('.arrow-position .right');

    this.desktopShow = this.slider.dataset.desktop;
    this.mobileShow = this.slider.dataset.mobile;

    this.sliderInit();
  }

  sliderInit() {
  	var slider = this.slider.getAttribute('id'),
  	    slider = '#'+slider,

  	    leftArrow = this.leftArrow.getAttribute('id'),
  	    leftArrow = '#'+leftArrow,

  	    rightArrow = this.rightArrow.getAttribute('id'),
  	    rightArrow = '#'+rightArrow,

  	    desktop = this.desktopShow * 1,
  	    mobile = this.mobileShow * 1;


  	$(slider).slick({

	  slidesToShow: desktop,
	  slidesToScroll: 1,
	  infinite: false,
	  arrows: true,
	
	  responsive: [{

	      breakpoint: 990,
	      settings: {
	        slidesToShow: desktop - 1,
	      }

	    }, {

	      breakpoint: 749,
	      settings: {
	        slidesToShow: mobile,
	      }

	    }, {

	      breakpoint: 300,
	      settings: "unslick" // destroys slick
	    }]
	});

 

	$(leftArrow).click(function () {
		$(slider).slick("slickPrev");
	});

	$(rightArrow).click(function () {
		$(slider).slick("slickNext");
	});
	$(leftArrow).addClass("slick-disabled");

	$(slider).on("afterChange", function () {
		if ($(slider + " .slick-prev").hasClass("slick-disabled")) {
			$(leftArrow).addClass("slick-disabled");
		} else {
			$(leftArrow).removeClass("slick-disabled");
		}
		if ($(slider + " .slick-next").hasClass("slick-disabled")) {
			$(rightArrow).addClass("slick-disabled");
		} else {
			$(rightArrow).removeClass("slick-disabled");
		}
	});

  }
}

customElements.define('featured-collection-new', FeaturedCollectionNew);

class BlogSliderNew extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.blog-slider-new');
    this.leftArrow = this.querySelector('.arrow-position .left');
    this.rightArrow = this.querySelector('.arrow-position .right');

    this.desktopShow = this.slider.dataset.desktop;
    this.mobileShow = this.slider.dataset.mobile;

     
    this.sliderInit();
  }

  sliderInit() {
  	var slider = this.slider.getAttribute('id'),
  	    slider = '#'+slider,

  	    leftArrow = this.leftArrow.getAttribute('id'),
  	    leftArrow = '#'+leftArrow,

  	    rightArrow = this.rightArrow.getAttribute('id'),
  	    rightArrow = '#'+rightArrow,

  	    desktop = this.desktopShow * 1,
  	    mobile = this.mobileShow * 1;


  	$(slider).slick({

	  slidesToShow: 3,
	  slidesToScroll: 1,
	  infinite: false,
	  arrows: true,
	
	  responsive: [{

	      breakpoint: 990,
	      settings: {
	        slidesToShow: 3 - 1,
	      }

	    }, {

	      breakpoint: 749,
	      settings: {
	        slidesToShow: 1,
	      }

	    }, {

	      breakpoint: 300,
	      settings: "unslick" // destroys slick
	    }]
	});

 

	$(leftArrow).click(function () {
		$(slider).slick("slickPrev");
	});

	$(rightArrow).click(function () {
		$(slider).slick("slickNext");
	});
	$(leftArrow).addClass("slick-disabled");


	$(slider).on("afterChange", function () {
		if ($(slider + " .slick-prev").hasClass("slick-disabled")) {
			$(leftArrow).addClass("slick-disabled");
		} else {
			$(leftArrow).removeClass("slick-disabled");
		}
		if ($(slider + " .slick-next").hasClass("slick-disabled")) {
			$(rightArrow).addClass("slick-disabled");
		} else {
			$(rightArrow).removeClass("slick-disabled");
		}
	});

  }
}

customElements.define('blog-slider-new', BlogSliderNew);

/* class BrandSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.brand-logo-slider');

    this.desktopShow = this.slider.dataset.desktop;
    this.mobileShow = this.slider.dataset.mobile;

     
    this.sliderInit();
  }

  sliderInit() {
  	var slider = this.slider.getAttribute('id'),
  	    slider = '#'+slider,

  	    desktop = this.desktopShow * 1,
  	    mobile = this.mobileShow * 1;


  	$(slider).slick({

	  slidesToShow: desktop,
	  slidesToScroll: 1,
	  infinite: false,
	  arrows: true,
	  prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><svg class="icon left-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"></polygon></svg></button>',
	  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg class="icon right-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"></polygon></svg></button>',
	  responsive: [{

	      breakpoint: 990,
	      settings: {
	        slidesToShow: desktop - 1,
	      }

	    }, {

	      breakpoint: 749,
	      settings: {
	        slidesToShow: mobile,
	      }

	    }, {

	      breakpoint: 300,
	      settings: "unslick" // destroys slick
	    }]
	});

  }
}

customElements.define('brand-logo', BrandSlider);

 */

// document.addEventListener('DOMContentLoaded', () => {
//     let navigation = document.querySelector('.header__inline-menu');

//     navigation.querySelectorAll('.header__menu-item').forEach((item) => {
//         item.addEventListener('click', function(e) {
//             e.preventDefault();
//             this.classList.add('dissolve');
//             let link = this.getAttribute('href');

//             setTimeout(() => {
//                 window.location.href = link; // Navigate to the specified URL
//             }, 100); // Match this time with the animation duration in the CSS
//         });
//     });
// });



class CarouselSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.carousel-slider');

    this.desktopShow = this.slider.dataset.desktop;
    this.mobileShow = this.slider.dataset.mobile;

     
    this.sliderInit();
  }

  sliderInit() {
  	var slider = this.slider.getAttribute('id'),
  	    slider = '#'+slider;

	  	$(slider).slick({
	  	  autoplay: true,
		  autoplaySpeed: 5000,
		  dots: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  infinite: false,
		  arrows: false,
		  fade: true,
		  pauseOnHover:false,
		  speed: 800,
		  cssEase: 'ease-out',
          adaptiveHeight: true,
		});

  }
}

customElements.define('carousel-slider', CarouselSlider);

class CarouselSliderBlog extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.carousel-slider-blog');

    this.desktopShow = this.slider.dataset.desktop;
    this.mobileShow = this.slider.dataset.mobile;

     
    this.sliderInit();
  }

  sliderInit() {
  	var slider = this.slider.getAttribute('id'),
  	    slider = '#'+slider;

	  	$(slider).slick({
	  	  autoplay: true,
		  autoplaySpeed: 5000,
		  dots: true,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  infinite: false,
		  arrows: false,
		  fade: true,
		  pauseOnHover:false,
		  speed: 800,
		  cssEase: 'ease-out',
		});

  }
}

customElements.define('carousel-slider-blog', CarouselSliderBlog);


class GalleryInfo extends HTMLElement {
  constructor() {
    super();

    this.sliderDesktop = this.querySelectorAll('.gallery-slider-desktop .gallery-slider');
    this.sliderMobile = this.querySelectorAll('.gallery-list-mobile .gallery-slider');

     

     
    this.sliderDesktopInit();
    //this.sliderMobileInit();

     
  }

  sliderDesktopInit() {
  	this.sliderDesktop.forEach( ( slider) => {
  		var slider = slider.getAttribute('id'),
  	    slider = '.gallery-slider-desktop #'+slider;


  // 	   $(slider).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		//     var i = (currentSlide ? currentSlide : 0) + 1;
		//     $(slider + ' .gallery-count').text(i + '/' + slick.slideCount);
		// });

	  	$(slider).slick({
		  dots: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  infinite: false,
		  arrows: false,
		  pauseOnHover:false,
		  speed: 800,
		  cssEase: 'ease-out',
		  arrows: true,
	 	  prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><svg class="icon left-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"></polygon></svg></button>',
	  	  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg class="icon right-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"></polygon></svg></button>',
	  	 
	  
		});
		$(slider).on('afterChange', function(event, slick, currentSlide) {
		  var currentSlideElement = $(slider).find('.slick-current'); // Find the current slide
		  var newHeight = currentSlideElement.outerHeight(); // Get the new height
		  $(slider).find('.slick-list').animate({ height: newHeight }, 300); // Animate the height change
		});

		 
  	});
  	
  	

  }
  // sliderMobileInit() {
  // 	this.sliderMobile.forEach( ( sliderMobile) => {
  // 		var sliderMobile = sliderMobile.getAttribute('id'),
  // 	    sliderMobile = '.gallery-list-mobile #'+sliderMobile;

	 //  	$(sliderMobile).slick({
		//   dots: false,
		//   slidesToShow: 1,
		//   slidesToScroll: 1,
		//   infinite: false,
		//   arrows: false,
		//   pauseOnHover:false,
		//   speed: 800,
		//   cssEase: 'ease-out',
		//   arrows: true,
	 // 	  prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><svg class="icon left-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"></polygon></svg></button>',
	 //  	  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg class="icon right-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"></polygon></svg></button>',
	  
		// });

		 
  // 	});
  	
  	

  // }
}

customElements.define('gallery-info', GalleryInfo);

window.addEventListener("load", function () {
  setTimeout(() => {
    // Function to find elements inside a shadow root
    function queryShadowRoot(selector, callback) {
      document.querySelectorAll("*").forEach((el) => {
        if (el.shadowRoot) {
          let shadowElement = el.shadowRoot.querySelector(selector);
          if (shadowElement) {
            callback(shadowElement);
          }
        }
      });
    }

    // Apply styles to .hotspot-container inside Shadow DOM
    queryShadowRoot(".hotspot-container", (hotspotContainer) => {
      hotspotContainer.style.setProperty("max-width", "max-content", "important");
    });

    // Apply styles to .commonninja-ribbon inside Shadow DOM
    queryShadowRoot(".commonninja-ribbon", (commonNinjaRibbon) => {
      commonNinjaRibbon.style.setProperty("display", "none", "important");
    });

  }, 3000); // 3-second delay
});



/* document.addEventListener("DOMContentLoaded", function () {
    function setupPriceCalculation() {
        console.log("Re-initializing price calculation...");

        const priceElement = document.querySelector(".price-list .price-text-style");
        const buyButton = document.querySelector(".buy-buttons .button");

        if (!priceElement || !buyButton) {
            console.log("Required elements not found, retrying...");
            setTimeout(setupPriceCalculation, 500);
            return;
        }

        // Refresh base price
        let basePrice = parseFloat(priceElement.dataset.price) || 0;

        // Store original button text
        const originalButtonText = buyButton.dataset.originalText || buyButton.innerText;
        buyButton.dataset.originalText = originalButtonText;

        // Restore previous quantity or default to 1
        let quantity = parseInt(sessionStorage.getItem("savedQuantity")) || 1;

        function updateTotal() {
            let total = (quantity * basePrice).toFixed(2);
            buyButton.innerText = `${originalButtonText} - $${total}`;
            sessionStorage.setItem("savedQuantity", quantity); // Save quantity

        }

        // Event delegation for plus/minus buttons
        document.body.addEventListener("click", function (event) {
            if (event.target.classList.contains("quantity-selector__button")) {
                if (event.target.classList.contains("plus-button-q")) {
                    quantity++;
                } else if (event.target.classList.contains("less-button-q") && quantity > 1) {
                    quantity--;
                }
                updateTotal();
            }
        });

        updateTotal();
    }

    // Run initially
    setupPriceCalculation();

    // Detect URL changes & refresh price while keeping quantity
    function handleURLChange() {
        setTimeout(setupPriceCalculation, 500); // Allow time for content to load
    }

    // Listen for browser navigation (back/forward)
    window.addEventListener("popstate", handleURLChange);

    // Listen for history changes via pushState or replaceState
    (function () {
        let originalPushState = history.pushState;
        let originalReplaceState = history.replaceState;

        history.pushState = function () {
            originalPushState.apply(this, arguments);
            handleURLChange();
        };

        history.replaceState = function () {
            originalReplaceState.apply(this, arguments);
            handleURLChange();
        };
    })();
}); */

/* document.addEventListener("DOMContentLoaded", function () {
    function updateTotal() {
        const quantityInput = document.querySelector(".quantity-selector__input");
        const priceElement = document.querySelector(".price-list .price-text-style");
        const buyButton = document.querySelector(".buy-buttons .button");

        if (!quantityInput || !priceElement || !buyButton) return;

        // Extract numerical price from the element (removes currency symbol)
        let basePrice = priceElement.dataset.price;
        
        // Get the current quantity
        let quantity = quantityInput.valueAsNumber || 1;

        // Calculate total price
        let total = (quantity * basePrice).toFixed(2);

        // Update the buy button text
        buyButton.innerText = `${buyButton.dataset.originalText || buyButton.innerText} - $${total}`;
        
        // Store the original button text if not already stored
        if (!buyButton.dataset.originalText) {
            buyButton.dataset.originalText = buyButton.innerText.split("- $")[0].trim();
        }

        console.log(basePrice, quantity, total)
    }

    // Run on input change
    document.addEventListener("input", function (event) {
        if (event.target.matches(".quantity-selector__input")) {
            updateTotal();
        }
    });

    // Function to handle URL changes and refresh values
    function handleUrlChange() {
        setTimeout(() => {
            updateTotal();
        }, 100); // Small delay to ensure elements are updated
    }

    // Detect URL changes using MutationObserver
    const observer = new MutationObserver(handleUrlChange);
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial execution
    updateTotal();
});  */


/* document.addEventListener("DOMContentLoaded", function () {

if ( document.querySelector(".projected-quantity")){
// Table mapping gallon values to square footage ranges
const ranges = [
  { gallons: 1, min: 201, max: 400 },
  { gallons: 1.5, min: 401, max: 600 },
  { gallons: 2, min: 601, max: 800 },
  { gallons: 2.5, min: 801, max: 1000 },
  { gallons: 3, min: 1001, max: 1200 },
  { gallons: 3.5, min: 1201, max: 1400 },
  { gallons: 4, min: 1401, max: 1600 },
  { gallons: 4.5, min: 1601, max: 1800 },
  { gallons: 5, min: 1801, max: 2000 },
  { gallons: 5.5, min: 2001, max: 2200 },
  { gallons: 6, min: 2201, max: 2400 },
  { gallons: 6.5, min: 2401, max: 2600 },
  { gallons: 7, min: 2601, max: 2800 },
  { gallons: 7.5, min: 2801, max: 3000 },
  { gallons: 8, min: 3001, max: 3200 },
  { gallons: 8.5, min: 3201, max: 3400 },
  { gallons: 9, min: 3401, max: 3600 },
  { gallons: 9.5, min: 3601, max: 3800 },
  { gallons: 10, min: 3801, max: 4000 },
];

// Function to find the correct min-max range based on the gallon quantity
function getRangeForGallons(gallons) {
  // Loop through the ranges to find which gallon value matches
  for (const range of ranges) {
    if (gallons === range.gallons) {
      return range;  // Return the corresponding range with min and max
    }
  }
  // If no match, return null
  return null;
}

// Function to update the .projected-quantity span
function updateProjectedQuantity() {
  // Get the selected quantity (gallons)
  const gallons = document.querySelector(".quantity-selector__input").valueAsNumber;

  // Check if the gallon quantity exceeds 8
  if (gallons > 10) {
    // If the quantity is greater than 8, show the special message
    document.querySelector(".projected-quantity").textContent = "You are covering a big area. Please get a special quote from our team.";
    return;
  }

  // Find the corresponding range for the gallon quantity
  const range = getRangeForGallons(gallons);

  // If the gallon quantity is not within any valid range, display an error message
  if (range === null) {
    document.querySelector(".projected-quantity").textContent = "Please enter a valid quantity within the allowed range.";
    return;
  }

  // Determine the proper singular or plural form for "gallon/gallons"
  const gallonText = gallons === 1 ? "gallon" : "gallons";

  // Update the .projected-quantity span with the message
  document.querySelector(".projected-quantity").textContent = `${gallons} ${gallonText} covers approx. ${range.min}–${range.max} sqft with one coat of paint`;
}

// Event listener to update the projected quantity when the input changes
document.querySelector(".quantity-selector__input").addEventListener("change", updateProjectedQuantity);

// Call the function initially to set the display when the page loads
updateProjectedQuantity();
}

}); */